import { Button, Grid } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import InputNumber from "../../../../components/hookForms/inputNumber";
import TextInput from "../../../../components/hookForms/textField";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

export interface IDialogProps {
    open: boolean;
    data: {
        open: boolean;
        id: string;
        nomeUsina: string;
        energiaKWP: string;
        energiaKWH: string;
        percentualDiferencaAceitavel: string;
        numeroInstalacao: string;
        tipoPesquisa: string;
        codigoProduto: string;
        crUsina: string;
        tipoUsina: string;
    };
    onClose?: any;
}

export default function DialogDetails({ open, data, onClose }: IDialogProps) {
    const {
        control,
        reset,
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            nomeUsina: "",
            energiaKWP: "",
            energiaKWH: "",
            percentualDiferencaAceitavel: "",
            numeroInstalacao: "",
            tipoPesquisa: "",
            codigoProduto: "",
            crUsina: "", //centro de custo
            tipoUsina: "",
        },
    });

    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data]);

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form>
                <DialogTitle>
                    Detalhes da Usina
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12}>
                            <TextInput name="nomeUsina" label="Nome" control={control} disabled={true} />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="energiaKWP"
                                label="Potência kWp"
                                control={control}
                                decimalScale={2}
                                maxLength={12}
                                disabled={true}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="energiaKWH"
                                label="Energia kWh"
                                control={control}
                                decimalScale={2}
                                maxLength={12}
                                disabled={true}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <InputNumber
                                name="percentualDiferencaAceitavel"
                                label="Diferença de percentual aceita %"
                                control={control}
                                decimalScale={2}
                                maxLength={6}
                                disabled={true}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <TextInput name="numeroInstalacao" label="Instalação" control={control} disabled={true} />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <TextInput name="tipoPesquisa" label="Tipo de Pesquisa" control={control} disabled={true} />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="codigoProduto"
                                label="Código do Produto"
                                control={control}
                                decimalScale={0}
                                noThousandSeparator
                                maxLength={10}
                                disabled={true}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <InputNumber
                                name="crUsina"
                                label="Centro de Custo"
                                control={control}
                                decimalScale={0}
                                noThousandSeparator
                                maxLength={10}
                                disabled={true}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <TextInput name="tipoUsina" label="Tipo" control={control} disabled={true} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Voltar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
